/**
 * import a whole directory of json, yaml or yml specs, as [{name, url}]
 */

const request = require.context("./../../docs/", true, /\.json|yaml|yml$/);

const allSpecFiles = request.keys();

const urls = allSpecFiles.map ( (filename) => {
    const fn = filename.replace(/\.\//ig, '');
    return {
        name: fn.replace(/\.(json|yaml|yml)$/ig, ''),
        url: request(filename)
    };
} );

module.exports = urls;
